<script setup lang="ts">

</script>

<template>
  <h1>TestHistory</h1>
  <router-link to="/academy/my-page/test-history/dashboard">Dashboard</router-link>
  |
  <router-link to="/academy/my-page/test-history/qualifying-test/all">QualifyingTest</router-link>
  |
  <router-link to="/academy/my-page/test-history/sharpen-skills">SharpenSkill</router-link>
  <router-view></router-view>
</template>

<style scoped>

</style>